import { FC } from "react";

import { useChoosePaymentContext } from "../contexts/ChoosePaymentContext";
import { usePaymentDetailsContext } from "../contexts/PaymentDetailsContext";
import { getReferencedPaymentId } from "../helpers/paymentReference";

import { parsePaymentCards } from "./helpers/parsePaymentCards";
import { PaymentCards } from "./PaymentCards";

import type { AssistantToolRendererProps } from "@/features/Assistant/contexts/AssistantConfigContext";

export const ConnectedPaymentCards: FC<AssistantToolRendererProps> = ({
  part,
  reply,
  isComposerDisabled,
  onMessageSent,
}) => {
  const paymentDetails = usePaymentDetailsContext();
  const choosePaymentContext = useChoosePaymentContext();
  const { purpose, payments, control } = parsePaymentCards(part.state === "output-available" ? part.output : null);
  const choosePayment =
    purpose === "choose" && !reply && !isComposerDisabled ? choosePaymentContext?.choosePayment : null;
  return (
    <PaymentCards
      payments={payments}
      chosenPaymentId={getReferencedPaymentId(reply)}
      onChoose={
        choosePayment
          ? (choice) => {
              onMessageSent("paymentCard");
              choosePayment(choice);
            }
          : undefined
      }
      onViewDetails={paymentDetails?.openPayment}
      actions={purpose === "show" ? { control } : undefined}
    />
  );
};
